<template>
  <div class="MomentsReport container-fluid full-height">
    <div class="main-content">
      <moments-report-filter-bar @selectedValues="updateSelectedValues" :enableBtns="enableViewAndExportBtns" v-bind:showExport="showExportButton"></moments-report-filter-bar>
      <hr width="97%" size="10px">
      <div class="row margin-Top-2Perc">
        <div class="col-md-11 col-lg-11 width margin-left-2Perc" v-if="selectedMomentsArr.length > 0">
          <span v-if="showExportButton" class="text-color-green font-size-16px">{{selectedMomentsArr.length > 1 ? 'Successfully processed all the selected ' + selectedMomentsArr.length + ' moments.' : 'Successfully processed selected moment.'}}</span>
          <span v-else class="text-color-orange">
            <div class="row">
              <div class="col-md-4 col-lg-4"></div>
              <div class="col-md-1 col-lg-1 padding-right-0px">
                <span class="loader"></span>
              </div>
              <div class="col-md-3 col-lg-3 text-align-left font-size-16px">
                Loading {{selectedMomentsArr.length - remainingUnProccessedMomentsArr.length}} out of {{selectedMomentsArr.length}}.
              </div>
              <div class="col-md-4 col-lg-4"></div>
            </div>
          </span>
        </div>
        <div class="col-md-11 col-lg-11 width margin-left-2Perc">
          <sortable-list v-if="showMomentReport" v-bind:responseObj="getMentoraMomentReportArr" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="1"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
    </div>
    <error-page v-if="isUserGroupAdmin"></error-page>        
  </div>  
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import MomentsReportFilterBar from '@/components/reports/moments_report/MomentsReportFilterBar'
import list from '@/pages/SortableList'
// import moment from 'moment'
import CopyrightElement from '@/components/CopyrightElement'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import AlertBox from '@/components/AlertOverlay'
import csvHelper from '@/utils/csv-helper'
import ErrorPage from '@/pages/Error'
import filter from 'lodash/filter'
import forEach from 'lodash/forEach'
import findIndex from 'lodash/findIndex'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      enableViewAndExportBtns: true,
      selectedMomentsArr: [],
      remainingUnProccessedMomentsArr: [],
      isExportBtnClicked: false,
      isViewBtnClicked: false,
      showExportButton: false,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showMomentReport: false,
      sortColumnNames: ['TotalLogins', 'TotalViews', 'TotalCompletions', 'UniqueUserCountForRDResponses', 'Ratings1Star', 'Ratings2Star', 'Ratings3Star', 'Ratings4Star', 'Ratings4Or5Star', 'Ratings5Star', 'TotalBookmarks', 'NotifClicked', 'TotalRatings'],
      columnAlias: ['Name of moment', 'Type of moment', 'Logins (#)', 'Logins (%)', 'Started reading (#)', 'Started reading (%)', 'Completed reading (#)', 'Completed reading (%)', 'R&D Engagement (#)', 'R&D Engagement (%)', 'Rating (1) (#)', 'Rating (1) (%)', 'Rating (2) (#)', 'Rating (2) (%)', 'Rating (3) (#)', 'Rating (3) (%)', 'Rating (4) (#)', 'Rating (4) (%)', 'Rating (4-5) (#)', 'Rating (4-5) (%)', 'Rating (5) (#)', 'Rating (5) (%)', 'Bookmarked (#)', 'Bookmarked (%)', 'Notification (#)', 'Notification (%)', 'Total Ratings'],
      columnRespKey: ['CourseTitle', 'TypeOfMoment', 'TotalLogins', 'PercentLogins', 'TotalViews', 'PercentViewsByLogins', 'TotalCompletions', 'PercentCompletionByViews', 'UniqueUserCountForRDResponses', 'PercentUniqueRDResponsesByViews', 'Ratings1Star', 'Percent1RatingsByTotalRatings', 'Ratings2Star', 'Percent2RatingsByTotalRatings', 'Ratings3Star', 'Percent3RatingsByTotalRatings', 'Ratings4Star', 'Percent4RatingsByTotalRatings', 'Ratings4Or5Star', 'Percent4or5RatingByTotalRatings', 'Ratings5Star', 'Percent5RatingByTotalRatings', 'TotalBookmarks', 'PercentBookmarkByViews', 'NotifClicked', 'PercentNotifByLogins', 'TotalRatings'],
      columnNameToShow: [],
      linkColumnNames: [],
      responseToPass: [],
      csvFileName: '',
      fromStartTS: null
    }
  },
  components: {
    'moments-report-filter-bar': MomentsReportFilterBar,
    'Copyright-Element': CopyrightElement,
    'sortable-list': list,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    markHasProccessedToFalse: function () {
      forEach(this.selectedMomentsArr, (obj) => {
        obj.hasProcessed = false
      })
    },
    resetDefaultVariables: function () {
      this.isExportBtnClicked = false
      this.isViewBtnClicked = false
      this.selectedMomentsArr = []
      this.fromStartTS = null
    },
    updateSelectedValues (value) {
      // AK: Reset the required variables before assigning new values into it.
      this.resetDefaultVariables()
      // AK: Update the values in parent file from filter component
      this.isExportBtnClicked = value.isExportBtnClicked
      this.isViewBtnClicked = value.isViewBtnClicked
      this.selectedMomentsArr = value.selectedMomentsArr
      this.fromStartTS = value.fromTS
      // AK: This button will show user only after all responses are get loaded
      if (this.isExportBtnClicked) {
        // AK: Check weather do we have any single response to export
        if (this.responseToPass.length > 0) {
          this.exportData()
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'No data found to export.'
        }
      } else {
        // AK: If user has click view button then do direct issue server call to the server
        this.enableViewAndExportBtns = false
        // AK: For safer side, mark all selected courses hasProccessed flag as false
        this.markHasProccessedToFalse()
        // console.log('this.selectedMomentsArr: ' + JSON.stringify(this.selectedMomentsArr))
        this.showExportButton = false
        if (this.selectedMomentsArr.length > 0) {
          // AK: Reset required variables in order to clean up last search report data from it.
          this.responseToPass = []
          this.bindColumnsNameAndAlias()
          // AK: Pick first coursemasterid from the array
          const firstCourseMasterId = this.selectedMomentsArr[0].coursemasterid
          this.getMentoraMomentReport(firstCourseMasterId, true)
        } else {
          // console.log('Found empty selectedMomentsArr array.')
        }
      }
    },
    markCurrentMomentAsProccessed: function (courseMasterId) {
      const foundIndex = findIndex(this.selectedMomentsArr, (obj) => {
        return obj.coursemasterid === courseMasterId
      })
      // console.log('Found Index: ' + foundIndex)
      if (foundIndex > -1) {
        this.selectedMomentsArr[foundIndex].hasProcessed = true
      }
    },
    getNonProccessedCourseMasterIds: function () {
      return filter(this.selectedMomentsArr, (currObj) => {
        return currObj.hasProcessed === false
      })
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
    },
    completePostSuccessOperations (courseMasterId) {
      // AK: Mark current coursemasterid as proccessed = true
      this.markCurrentMomentAsProccessed(courseMasterId)
      // AK: Get next unproccessed coursemasterid list
      this.remainingUnProccessedMomentsArr = this.getNonProccessedCourseMasterIds()
      // console.log('remainingUnProccessedMomentsArr: ' + JSON.stringify(remainingUnProccessedMomentsArr))
      if (this.remainingUnProccessedMomentsArr.length > 0) {
        this.getMentoraMomentReport(this.remainingUnProccessedMomentsArr[0].coursemasterid, this.responseToPass.length === 0)
      } else {
        // AK: If we successfully proccessed selected all coursemaster list then start enable and start showing export button
        this.enableViewAndExportBtns = true
        this.showExportButton = true
      }
    },
    getMentoraMomentReport: function (courseMasterId, showSpinner) {
      var storeObj = this.$store
      var _this = this
      // console.log('courseMasterId:' + courseMasterId)
      if (courseMasterId !== undefined && courseMasterId !== null && courseMasterId !== 'null' && courseMasterId !== '') {
        if (showSpinner) {
          this.$store.state.isLoading = true
        }
        reportService.getMomentsReports(storeObj.state.access_token, courseMasterId, this.fromStartTS).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Reports
              _this.$store.state.isLoading = false
              _this.bindResponseObj(responseObj.data)
              _this.showMomentReport = true
              // console.log('this.selectedMOTDObj >>> ' + JSON.stringify(responseObj.data))
              _this.completePostSuccessOperations(courseMasterId)
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            _this.completePostSuccessOperations(courseMasterId)
          }
        )
      } else {
        console.log('VALUES are NULL hence declined LOADING Mentora Moments Report List')
      }
    },
    formatAndShowDate: function (date) {
      if (date !== undefined) {
        var dateToPass = date
        if (dateToPass.indexOf('Z') === -1) {
          dateToPass += 'Z'
        }
        return dmAdminUtils.formatDateAndTime(dateToPass)
      }
    },
    bindResponseObj: function (currMomentObj) {
      var obj = {
        'CourseTitle': currMomentObj.CourseTitle,
        'TypeOfMoment': currMomentObj.TypeOfMoment === undefined || currMomentObj.TypeOfMoment === null || currMomentObj.TypeOfMoment === 'null' || currMomentObj.TypeOfMoment === 'undefined' || currMomentObj.TypeOfMoment === '' ? 'NA' : currMomentObj.TypeOfMoment,
        'TotalLogins': currMomentObj.TotalLogins,
        'PercentLogins': parseInt(currMomentObj.PercentLogins) + '%',
        'TotalViews': currMomentObj.TotalViews,
        'PercentViewsByLogins': parseInt(currMomentObj.PercentViewsByLogins) + '%',
        'TotalCompletions': currMomentObj.TotalCompletions,
        'PercentCompletionByViews': parseInt(currMomentObj.PercentCompletionByViews) + '%',
        'UniqueUserCountForRDResponses': currMomentObj.UniqueUserCountForRDResponses,
        'PercentUniqueRDResponsesByViews': parseInt(currMomentObj.PercentUniqueRDResponsesByViews) + '%',
        'Ratings1Star': currMomentObj.Ratings1Star,
        'Percent1RatingsByTotalRatings': parseInt(currMomentObj.Percent1RatingsByTotalRatings) + '%',
        'Ratings2Star': currMomentObj.Ratings2Star,
        'Percent2RatingsByTotalRatings': parseInt(currMomentObj.Percent2RatingsByTotalRatings) + '%',
        'Ratings3Star': currMomentObj.Ratings3Star,
        'Percent3RatingsByTotalRatings': parseInt(currMomentObj.Percent3RatingsByTotalRatings) + '%',
        'Ratings4Star': currMomentObj.Ratings4Star,
        'Percent4RatingsByTotalRatings': parseInt(currMomentObj.Percent4RatingsByTotalRatings) + '%',
        'Ratings4Or5Star': currMomentObj.Ratings4Or5Star,
        'Percent4or5RatingByTotalRatings': parseInt(currMomentObj.Percent4or5RatingByTotalRatings) + '%',
        'Ratings5Star': currMomentObj.Ratings5Star,
        'Percent5RatingByTotalRatings': parseInt(currMomentObj.Percent5RatingByTotalRatings) + '%',
        'TotalBookmarks': currMomentObj.TotalBookmarks,
        'PercentBookmarkByViews': parseInt(currMomentObj.PercentBookmarkByViews) + '%',
        'NotifClicked': currMomentObj.NotifClicked,
        'PercentNotifByLogins': parseInt(currMomentObj.PercentNotifByLogins) + '%',
        'TotalRatings': currMomentObj.TotalRatings
      }
      this.responseToPass.push(obj)
    },
    exportData: function () {
      return csvHelper.export(this.getMentoraMomentReportArr, this.columnRespKey, this.columnAlias, 'Mentora Moments Report')
    }
  },
  computed: {
    getMentoraMomentReportArr: {
      get: function () {
        return this.responseToPass
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'MomentsReport'
}
</script>

<style scoped>
.full-height {
  min-height: 80vh;
}
.MomentsReport {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.width {
  width: 100% !important;
}
.width1 {
  width: 97.3% !important;
}
.margin-left-0point2Perc {
  margin-left: 0.2% !important;
}
.margin-left-1point6Perc {
  margin-left: 1.6% !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
.padding-bottom-0Perc{
  padding-bottom: 0px; 
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-left-1point6Perc {
  margin-left: 2.8% !important;
}
.width2 {
  width: 95.2% !important;
}
.margin-left-1point6Perc {
  margin-left: 2.8% !important;
}
.text-color-green {
  color: green;
}
.text-color-orange {
  color: #f39c12;
}
.loader {
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #f39c12; /* Blue */
  border-radius: 50%;
  width: 23px;
  height: 23px;
  margin: auto;
  float: right;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.text-align-left {
  text-align: left;
}
.font-size-16px {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/MomentsReport.vue